var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box1"},[(_vm.shows)?_c('Server_Component',{attrs:{"changeSercer":_vm.changeSercer}}):_vm._e(),_c('Footer_Compontent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }